/**
 * @Author: wuhaoran
 * @Date: 2023-06-15 11:36:02
 * @LastEditTime: 2023-11-13
 * @LastEditors: Please set LastEditors
 * @Description: 
 */
export const beiAnBase = '冀ICP备2023017986号';

export const beiAnList = {
    'kangtaoyun.com': `${beiAnBase}-1`,
    'kangtaoyun.cn': `${beiAnBase}-4`,
    'kangtaotech.com': `${beiAnBase}-2`,
    'kangtaotech.cn': `${beiAnBase}-3`,
}

export const mpsBeiAnBase = '冀公网安备1305020200043';

export const mpsBeiAnList = {
    'kangtaoyun.com': `${mpsBeiAnBase}9号`,
    'kangtaoyun.cn': `${mpsBeiAnBase}6号`,
    'kangtaotech.com': `${mpsBeiAnBase}8号`,
    'kangtaotech.cn': `${mpsBeiAnBase}7号`,
}